var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer container"},[(_vm.items.length > 0)?_c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item.name,staticClass:"navItems"},[_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(item.label))])],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }